import React, { useState } from "react";
import PropTypes from "prop-types";
import i18n from "@/translate/i18n";
import { ReactComponent as CopyIcon } from "@/assets/images/copy.svg";
import { ReactComponent as EditIcon } from "@/assets/images/pencil.svg";

export function FakeInput({
  label = "",
  value = "",
  description = "",
  dataCopy,
  className,
  isEditable,
  onClick,
  hasAnimation = false,
}) {
  const [isCopied, setIsCopied] = useState(false);
  const [copyAnimation, setCopyAnimation] = useState(true);

  const handleCopy = async () => {
    if (!dataCopy) return;
    try {
      setCopyAnimation(false);
      await navigator.clipboard.writeText(dataCopy);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div
      className={`flex flex-col items-center w-full h-[66px] text-left mb-5 ${className}`}
      onClick={onClick}
      onKeyDown={(e) => {
        if (onClick && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          onClick(e);
        }
      }}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      aria-label={onClick ? `Editar ${label}` : undefined}
    >
      <span className="pl-[5px] self-start text-sm font-semibold text-black">
        {label}
      </span>
      <div
        className={`flex gap-1 ${
          hasAnimation &&
          copyAnimation &&
          "border border-[1.5px] animate-pulsing-border"
        } relative items-center justify-between mt-2 h-10 bg-gray-300 min-h-[40px] w-full min-w-full px-5 rounded text-black box-border`}
      >
        {isEditable && <EditIcon className="absolute right-[12px] h-[18px]" />}
        <span className="min-w-0 break-words leading-none">{value}</span>
        {dataCopy && (
          <button
            className={`flex items-center justify-center text-sm gap-2 h-full w-32 cursor-pointer border-none relative -right-5 ${
              hasAnimation && copyAnimation ? "animate-copy-button" : ""
            } ${
              isCopied ? "bg-cripten-green text-white" : "bg-cripten-primary"
            }`}
            onClick={handleCopy}
            type="button"
          >
            {!isCopied && <CopyIcon className="w-5" />}
            {isCopied ? i18n.t("general.copied") : i18n.t("general.copy")}
          </button>
        )}
        {description && <span>{description}</span>}
      </div>
    </div>
  );
}

FakeInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  dataCopy: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  isEditable: PropTypes.bool,
  hasAnimation: PropTypes.bool,
};
